import styled from 'styled-components';
import { PaginationComponent, ModalSubBranchesComponent } from '../../../components/';
import { format } from 'date-fns';
import Swal from 'sweetalert2';
const TableDiv = styled.div`
    opacity: ${(props) => (props.loading ? '0.4' : '1')};
    pointer-events: ${(props) => (props.loading ? 'none' : 'auto')};
`;

const InputStyle = styled.input`
    &:focus {
        // outline: ${(props) => (props.loading ? 'none' : 'auto')};
        box-shadow: ${(props) => (props.loading ? 'none' : 'auto')};
    }
`;

const NoRecordIcon = styled.i`
    font-size: 50px;
    color: grey;
`;

export default function VendorTable({
    SpinnerWrapper,
    formData,
    loading,
    vendorList,
    tableDetails,
    setSearch,
    handleEdit,
    handleDelete,
    loadVendors,
    setModalState
}) {
    const showVendorDetails = (e, data) => {
        e.preventDefault();
        setModalState({
            isOpen: true,
            data,
            formData: null
        });
    };

    return (
        <div>
            <div className="card overflow-auto">
                <div className="card-body">
                    <h5 className="card-title">Vendor List</h5>
                    <div>
                        <SpinnerWrapper loading={loading ? 1 : 0}>
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                                style={{ width: '30px', height: '30px' }}
                            ></span>
                        </SpinnerWrapper>
                    </div>

                    <TableDiv loading={loading ? 1 : 0}>
                        <div className="row justify-content-end">
                            <div className="col-6 mb-3">
                                <InputStyle
                                    loading={loading ? 1 : 0}
                                    id="search"
                                    type="text"
                                    className="form-control"
                                    placeholder="Search"
                                    value={tableDetails.search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                        </div>

                        <table className="table table-hover">
                            <thead>
                                <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                                    <th scope="col">ID</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Address</th>
                                    <th scope="col">Code</th>
                                    <th scope="col">Tin</th>
                                    <th scope="col">Desription</th>
                                    <th scope="col">Created</th>
                                    <th scope="col">Last Update</th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {vendorList &&
                                    vendorList.map((item, index) => {
                                        return (
                                            <tr key={'user_' + index + item.VENDOR_ID}>
                                                <td scope="row">{item.VENDOR_ID}</td>
                                                <th>
                                                    <a
                                                        href="#"
                                                        // data-bs-toggle="modal"
                                                        // data-bs-target="#vendormodal"
                                                        // onClick={(e) => showVendorDetails(e, item)}
                                                        onClick={(e) => e.preventDefault()}
                                                    >
                                                        {item.VENDOR_NAME}
                                                    </a>
                                                </th>
                                                <td>{item.VENDOR_EMAIL}</td>
                                                <td>{item.VENDOR_ADDRESS}</td>
                                                <td>{item.VENDOR_CODE}</td>
                                                <td>{item.VENDOR_TIN}</td>
                                                <td>{item.VENDOR_DESCRIPTION}</td>
                                                <td>{format(item.CREATED_AT, 'MMMM dd, yyyy h:mm a')}</td>
                                                <td>{format(item.UPDATED_AT, 'MMMM dd, yyyy h:mm a')}</td>
                                                <td width="2%">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary rounded-pill btn-sm"
                                                        title="Edit"
                                                        onClick={() => handleEdit(item)}
                                                    >
                                                        <i className="bi bi-pencil"></i>
                                                    </button>
                                                </td>
                                                <td width="">
                                                    {formData.VENDOR_ID !== item.VENDOR_ID ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger rounded-pill btn-sm"
                                                            title="Delete"
                                                            onClick={() =>
                                                                handleDelete({
                                                                    id: item.VENDOR_ID
                                                                })
                                                            }
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    ) : (
                                                        <i>Editing...</i>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                {!vendorList ||
                                    (!vendorList.length && (
                                        <tr>
                                            <td colSpan="10" className="text-center p-0">
                                                <div className="p-2" style={{ backgroundColor: '#FAF9F6' }}>
                                                    <NoRecordIcon className="bi bi-exclamation-triangle" />
                                                    <div>No vendors available.</div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>

                        <PaginationComponent
                            totalData={tableDetails.totalData}
                            currentPage={tableDetails.currentPage}
                            totalPages={tableDetails.totalPages}
                            onPageChange={loadVendors}
                        />
                    </TableDiv>
                </div>
            </div>
        </div>
    );
}
